import React from 'react';
import Switch from './Switch';
import { useTheme } from '../../contexts/ThemeProvider';

const SwitchWrapper = ({ children }) => {
	const { toggleTheme } = useTheme();

	return (
		<div>
			{children}
			<Switch onThemeChange={toggleTheme} />
		</div>
	);
};

export default SwitchWrapper;
